 import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";

const DeviceModelPopup = ({ onSave, deviceData, isEditing }) => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get(`${apiUrl}/company/locations?type=basic`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLocations(response.data);
      } catch (error) {
        console.error("Error fetching locations:", error);
        toast.error("Failed to fetch locations. Please try again later.");
      }
    };

    fetchLocations();

    if (isEditing && deviceData) {
      setValue("device_sr_no", deviceData.device_sr_no);
      setValue("device_desc", deviceData.device_desc);
      setValue("locationid", deviceData.locationid);
      setValue("status", deviceData.status);
    } else {
      reset();
    }
  }, [isEditing, deviceData, reset, setValue, apiUrl, token]);

  const onSubmit = async (data) => {
    try {
      const url = isEditing ? `${apiUrl}/devices/update/${deviceData.id}` : `${apiUrl}/devices/device`;
      const method = isEditing ? 'put' : 'post';
      const response = await axios[method](url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Device ${isEditing ? 'updated' : 'added'} successfully`);
     // onSave(response.data);
      reset();
      document.querySelector('[data-bs-dismiss="modal"]').click(); // Close the modal
    } catch (error) {
      toast.error(`Failed to ${isEditing ? 'update' : 'add'} device. Please try again later.`);
    }
  };

  return (
<div id="add_device" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "40%" }}>
    <div className="modal-content h-100 d-flex flex-column">
      <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column h-100">
        <div className="modal-header">
          <h5 className="modal-title">{isEditing ? "Edit Device" : "Add Device"}</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
          <div className="scrollable-container">
            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">
                Device Serial Number <span className="text-danger">*</span>
              </label>
              <div className="col-md-8">
                <input
                  className="form-control"
                  type="text"
                  {...register("device_sr_no", { required: "Device Serial Number is required" })}
                />
                {errors.device_sr_no && <span className="text-danger">{errors.device_sr_no.message}</span>}
              </div>
            </div>

            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">
                Description <span className="text-danger">*</span>
              </label>
              <div className="col-md-8">
                <input
                  className="form-control"
                  type="text"
                  {...register("device_desc", { required: "Description is required" })}
                />
                {errors.device_desc && <span className="text-danger">{errors.device_desc.message}</span>}
              </div>
            </div>

            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">
                Location <span className="text-danger">*</span>
              </label>
              <div className="col-md-8">
                <select
                  className="form-control"
                  {...register("locationid", { required: "Location is required" })}
                >
                  {locations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.location}
                    </option>
                  ))}
                </select>
                {errors.locationid && <span className="text-danger">{errors.locationid.message}</span>}
              </div>
            </div>

            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">
                Status <span className="text-danger">*</span>
              </label>
              <div className="col-md-8">
                <select
                  className="form-control"
                  {...register("status", { required: "Status is required" })}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                {errors.status && <span className="text-danger">{errors.status.message}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
          <button className="btn btn-primary submit-btn" type="submit">
            {isEditing ? "Save Changes" : "Submit"}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


  );
};

export default DeviceModelPopup;
